import { track } from "src/lib/analytics";

const HOME_LINK_CLICKED_EVENT = "Home Link Clicked";

/** Surface on the homepage a link/CTA click originated from. */
export type HomeLinkSection =
  | "recent_ad"
  | "recent_campaign"
  | "create_ad_filled_cta"
  | "create_campaign_filled_cta"
  | "create_ad_empty_cta"
  | "create_campaign_empty_cta"
  | "create_report_empty_cta"
  | "all_reports"
  | "report_card"
  | "chat_session"
  | "recently_viewed"
  | "activity"
  | "quick_action"
  | "drafts";

type TrackHomeLinkClickParams = {
  section: HomeLinkSection;
  label: string;
  href?: string;
};

/** Fires a single, consistent analytics event for every homepage link click. */
export const trackHomeLinkClick = ({
  section,
  label,
  href,
}: TrackHomeLinkClickParams): void => {
  track(HOME_LINK_CLICKED_EVENT, { section, label, href });
};
